var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBonlivaLogoPayoff = function SvgBonlivaLogoPayoff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520.14 134.54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff867b;}.cls-2{fill:#495358;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bonliva_logo_payoff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.52,1.55c16,0,25,9.38,25,22.11,0,8.45-5.09,15.28-11.92,17.6,8,2,14.47,9.26,14.47,19.45,0,13.31-10,22.92-25.35,22.92H0V1.55ZM27.09,35.47c7.29,0,11.69-4.05,11.69-10.3S34.73,15,27,15H15.74V35.47Zm1.62,34.84c7.76,0,12.39-4.05,12.39-10.65s-4.17-11-12.16-11H15.74V70.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,36.4a36.23,36.23,0,0,1,5.21-18.76,36.4,36.4,0,1,0,50,50A36.4,36.4,0,0,1,82,36.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.81,36.4A36.4,36.4,0,0,0,87.22,17.64a36.4,36.4,0,0,1,50,50A36.38,36.38,0,0,0,154.81,36.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.63,83.63V1.55h16.88V83.63Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "281.36 68.1 281.36 1.55 265.33 1.55 265.33 83.63 312.06 83.63 318.56 68.1 281.36 68.1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "223.92 1.56 223.92 55.32 186.93 1.55 186.93 1.55 168.26 1.55 171.76 6.64 171.76 83.63 187.74 83.63 187.74 29.86 224.73 83.63 239.9 83.63 239.9 1.56 223.92 1.56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "428.16 1.55 406.19 61.89 384.22 1.55 366.64 1.55 398.31 83.63 414.06 83.63 445.73 1.55 428.16 1.55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488,6.67,490,1.55H474.53L440.21,83.63H457l6.81-16.91h32.8l6.81,16.91h16.75ZM469.65,52.13,480.17,26,490.7,52.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.57,118.32l2.75,10.73L152,118.32h3.27l-4.16,16h-3l-2.81-10.52-2.81,10.52h-3l-4.16-16h3.35l2.6,10.73L144,118.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171,118.32v2.91h-7.56v3.48h6.86v2.83h-6.86v3.79H171v2.94H160.19v-16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192,118.06a6.33,6.33,0,0,1,6.68,5.4h-3.3A3.35,3.35,0,0,0,192,121c-2.55,0-4.05,2.23-4.05,5.27s1.51,5.27,4.05,5.27a3.34,3.34,0,0,0,3.38-2.47h3.3a6.33,6.33,0,0,1-6.68,5.43c-4.26,0-7.43-3.35-7.43-8.24S187.73,118.06,192,118.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.74,134.54c-4.44,0-7.54-3.48-7.54-8.24s3.09-8.24,7.54-8.24,7.56,3.46,7.56,8.24S214.18,134.54,209.74,134.54Zm0-13.51c-2.52,0-4.16,2.16-4.16,5.27s1.64,5.27,4.16,5.27,4.21-2.16,4.21-5.27S212.29,121,209.74,121Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235,134.28H232.4l-7.54-10.63v10.63h-3.2v-16h3.12l7,10.08V118.32H235Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.56,134.28h-2.62l-7.54-10.63v10.63h-3.2v-16h3.12l7,10.08V118.32h3.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.58,118.32v2.91H264v3.48h6.86v2.83H264v3.79h7.56v2.94H260.74v-16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.4,118.06a6.33,6.33,0,0,1,6.68,5.4h-3.3A3.35,3.35,0,0,0,283.4,121c-2.55,0-4.05,2.23-4.05,5.27s1.51,5.27,4.05,5.27a3.34,3.34,0,0,0,3.38-2.47h3.3a6.33,6.33,0,0,1-6.68,5.43c-4.26,0-7.43-3.35-7.43-8.24S279.14,118.06,283.4,118.06Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.57,118.32h13.62v2.91H301v13h-3.35v-13h-5.12Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.77,118.06a6.33,6.33,0,0,1,6.68,5.4h-3.3a3.35,3.35,0,0,0-3.38-2.44c-2.55,0-4.05,2.23-4.05,5.27s1.51,5.27,4.05,5.27a3.34,3.34,0,0,0,3.38-2.47h3.3a6.33,6.33,0,0,1-6.68,5.43c-4.26,0-7.43-3.35-7.43-8.24S322.51,118.06,326.77,118.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.5,118.32l6.11,16h-3.38l-1.43-3.85h-6l-1.4,3.85H336.1l6.11-16Zm-3.64,9.3h3.9l-1.95-5.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.91,128.33v6h-3.3v-16h6.57c3.35,0,5.59,1.79,5.59,5.07a4.5,4.5,0,0,1-3.64,4.7l4.21,6.18H364.6l-3.95-6Zm0-2.73H362c1.66,0,2.52-.88,2.52-2.21s-.86-2.23-2.52-2.23h-3.07Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.19,118.32v2.91h-7.56v3.48h6.86v2.83h-6.86v3.79h7.56v2.94H373.36v-16Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBonlivaLogoPayoff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bonliva-logo-payoff.37e92477939362b738dba4b59841165c.svg";